import apiClient from "./api";

export async function eomGetExpired(data) {
    try {
      const response = await apiClient.get("/eomws/eomgetexpired_new", {params: data}); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function downloadExportOrphanHospitals(data) {
    try {
      const response = await apiClient.get('/eomws/exportorphanhospitals', {
        responseType: 'blob', // Ensures the response is treated as a binary file
        params:data
      });
  
      // Create a URL for the blob
      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
  
      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "Ορφανά από Μονάδα εφαρμογής.xlsx");
  
      // Append the link to the document, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      // Revoke the URL to release memory
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  }

  export async function downloadExportOrphanInstitutes(data) {
    try {
      const response = await apiClient.get('/eomws/exportorphanistitutes', {
        responseType: 'blob', // Ensures the response is treated as a binary file
        params:data
      });
  
      // Create a URL for the blob
      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
  
      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "Ορφανά από Ιδρύματα ιστών.xlsx");
  
      // Append the link to the document, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      // Revoke the URL to release memory
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  }

  export async function downloadExportUsedExpired(data) {
    try {
      const response = await apiClient.get('/eomws/exportusedexpired', {
        responseType: 'blob', // Ensures the response is treated as a binary file
        params:data
      });
  
      // Create a URL for the blob
      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
  
      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "Εφαρμοσμένα ληγμένα.xlsx");
  
      // Append the link to the document, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      // Revoke the URL to release memory
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  }